// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"signin-widget-with-providers_widgetContainer__q4SrC"};